export { Input } from "@mantine/core";
export { inputOverrides } from "./Input.config";
